import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

function root({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={twMerge('mt-4 flex flex-col gap-2', className)} {...rest} />
  )
}

interface ContentProps extends ComponentProps<'div'> {
  hasFile?: boolean
  isNotAdminOrSuperAdmin?: boolean
  isOwnerOfTheResource?: boolean
}

function content({
  className,
  hasFile = false,
  isNotAdminOrSuperAdmin = false,
  isOwnerOfTheResource = false,
  ...rest
}: ContentProps) {
  return (
    <div
      className={twMerge(
        'flex w-full cursor-pointer flex-col items-center justify-between gap-2 rounded-lg border bg-white p-3',
        'hover:border-bios-300 transition-all hover:shadow-lg sm:flex-row md:gap-0',
        hasFile && isNotAdminOrSuperAdmin && 'cursor-default',
        isOwnerOfTheResource && 'cursor-default',

        className,
      )}
      {...rest}
    />
  )
}

export const PersonalDocumentList = {
  Root: root,
  Content: content,
}
